import {ResponsiveSheet} from '@chekinapp/ui';
import {
  ShareRegistrationLink,
  type ShareRegistrationLinkProps,
} from './ShareRegistrationLink';

type Props = ShareRegistrationLinkProps & {
  open: boolean;
  onClose: () => void;
};

function ShareRegistrationLinkSheet({open, onClose, ...linkProps}: Props) {
  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      dialogClassName="!max-w-[430px]"
      closeOnOverlayClick
    >
      <ShareRegistrationLink {...linkProps} />
    </ResponsiveSheet>
  );
}

export {ShareRegistrationLinkSheet};
